import { useSelector } from 'react-redux';

import * as programsSelectors from '@makemydeal/dr-dash-store/selectors/programsSelectors';
import type { StateTree } from '@makemydeal/dr-dash-types';

import DealTypeSourceBadge from '../../dealTypeDropdown/DealTypeSourceBadge';
import { DealTypeSource, useDealTypeSource } from '../../dealTypeDropdown/useDealTypeSource';
import { ProgramNameBadge } from './ProgramNameBadge';

export const ScenarioSourceBadge = () => {
    const source = useDealTypeSource();
    const programName = useSelector((state: StateTree) =>
        source === DealTypeSource.PROGRAM ? programsSelectors.getLenderProgramDisplay(state) : ''
    );

    return programName ? <ProgramNameBadge name={programName} /> : <DealTypeSourceBadge />;
};
